module.exports = __webpack_public_path__ + "static/img/Home05_1@2x.584ab4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home05_1@2x.png
// module id = iDUl
// module chunks = 1